import { useState } from 'react';
import { Link } from 'react-router-dom';
import { MobileSidebar } from "@lecartte/shared-ui/components/MobileSidebar";
import { Image } from "@lecartte/shared-ui/components/Image";
import LogoLecartte from '@/assets/images/logo.svg';
import { appConfig } from '@/config/app';
import { AdminMobileSearchInput } from './AdminMobileSearchInput';

const LECARTTE_CLIENT_URL = process.env.LECARTTE_CLIENT_URL || 'http://localhost:3015';

const NAV_ITEMS = [
  { href: LECARTTE_CLIENT_URL, label: 'Inicio' },
  { href: `${LECARTTE_CLIENT_URL}/restaurantes`, label: 'Restaurantes' },
  { href: `${LECARTTE_CLIENT_URL}/planos`, label: 'Planos' },
  { href: `${LECARTTE_CLIENT_URL}/rastrear-pedido`, label: 'Rastrear pedido' },
  { href: `${LECARTTE_CLIENT_URL}/contato`, label: 'Contato' },
];

export const LandingHeader = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const headerClass = 'fixed top-0 left-0 right-0 z-50 border-b border-slate-200/70 bg-white/95 backdrop-blur-sm shadow-sm';

  return (
    <>
      <MobileSidebar
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
        logo={
          <a href={LECARTTE_CLIENT_URL} onClick={() => setIsMobileMenuOpen(false)}>
            <Image src={LogoLecartte} alt={appConfig.name} width={72} height={32} className="h-8 w-auto rounded-lg object-cover" />
          </a>
        }
        items={NAV_ITEMS}
        footer={
          <div className="flex flex-col gap-2">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className="w-full rounded-xl border border-slate-200 px-4 py-3 text-center text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
            >
              Fazer login
            </Link>
            <Link
              to="/criar-conta"
              onClick={() => setIsMobileMenuOpen(false)}
              className="w-full rounded-xl bg-primary px-4 py-3 text-center text-sm font-semibold text-white transition hover:opacity-90"
            >
              Criar restaurante
            </Link>
          </div>
        }
      >
        <AdminMobileSearchInput onNavigate={() => setIsMobileMenuOpen(false)} />
      </MobileSidebar>

      <header className={headerClass}>
        <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-6 px-6 py-4">
          {/* Logo */}
          <a href={LECARTTE_CLIENT_URL} className="flex items-center gap-2 flex-shrink-0">
            <Image
              src={LogoLecartte}
              alt={appConfig.name}
              width={100}
              height={44}
              priority
              className="h-[44px] w-[100px] rounded-2xl object-cover shadow-sm"
            />
          </a>

          {/* Nav */}
          <nav className="hidden lg:flex items-center gap-6 text-sm font-semibold">
            {NAV_ITEMS.map(({ href, label }) => (
              <a
                key={href}
                href={href}
                className="transition-colors hover:text-slate-900 text-slate-600"
              >
                {label}
              </a>
            ))}
          </nav>

          {/* Actions */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <button
              type="button"
              onClick={() => setIsMobileMenuOpen(true)}
              className="flex h-9 w-9 items-center justify-center rounded-full lg:hidden border border-slate-200 bg-white/80 text-slate-700"
              aria-label="Abrir menu"
            >
              <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>

            <a
              href="/login"
              className="hidden rounded-full border border-slate-200 bg-white/80 px-4 py-2 text-xs font-semibold text-slate-600 transition hover:border-[var(--color-primary)] hover:text-[var(--color-primary)] sm:inline-flex"
            >
              Login
            </a>
            <a
              href={LECARTTE_CLIENT_URL}
              className="hidden rounded-full border border-slate-200 bg-white/80 px-4 py-2 text-xs font-semibold text-slate-600 transition hover:border-[var(--color-primary)] hover:text-[var(--color-primary)] sm:inline-flex"
            >
              Acessar cardápio
            </a>
          </div>
        </div>
      </header>
    </>
  );
};
